
import { defineComponent, computed, getCurrentInstance } from 'vue'

export default defineComponent({
  setup() {
    const instance = getCurrentInstance()
    const loading = computed(() => {
      const root = instance?.proxy?.$root as { isLoading?: boolean } | undefined
      return root?.isLoading ?? false
    })

    return {
      loading
    }
  }
})
